// @flow
import React from 'react'
import I18n from 'i18n-react'
import Loadable from 'react-loadable'
import GuardXLogger from 'guard-x-logger'

import logDataSerializer from '../../Core/Serializers/LogDataSerializer'

const CallbackFormSubmodule = Loadable({
  loader: () => import('../../submodules/callback-form/src'),
  loading() {
    return <span />
  },
})

// types
import type { ImmutableType } from '../../Core/Types/ImmutableTypes'

type CallbackFormAppProps = {
  affiliate: string,
  automaticallySend: boolean,
  confirmModalEnabled?: boolean,
  data: {
    callbackQuoteId?: string,
    contractId?: string,
  },
  formData: Object & ImmutableType,
  goBack: () => void,
  isBackOffice: boolean,
  modalOpened: boolean,
  onClose: () => void,
  productName: string,
  renderNotOpened?: boolean,
  requestId: string,
  showText: boolean,
  token: string,
  website: string,
}

type CallbackFormAppState = {
  setDataCl: null | Function,
  sendCallback: null | Function,
  toggleModal: null | Function,
}

export default class CallbackFormApp extends React.Component<CallbackFormAppProps, CallbackFormAppState> {
  static defaultProps = {
    data: {},
    isBackOffice: false,
    renderNotOpened: false,
  }

  state = {
    setDataCl: null,
    sendCallback: null,
    toggleModal: null,
  }

  componentDidUpdate = (prevProps: CallbackFormAppProps) => {
    if (
      this.props.automaticallySend &&
      !prevProps.automaticallySend &&
      typeof this.state.setDataCl === 'function' &&
      this.props.formData.getIn(['policyHolder', 'phoneNumber'])
    ) {
      const data = this.handleCreate(this.state.setDataCl, this.state.sendCallback)
      // this.state.sendCallback(false, false, {
      //   firstName: this.props.formData.getIn(['policyHolder', 'firstName'], ''),
      // })
      GuardXLogger.captureMessage('AUTOMATICALLY_SEND_CALLBACK', {
        extra: {
          action: 'AUTOMATICALLY_SEND_CALLBACK',
          data: logDataSerializer(data),
        }
      })
    }
    if (this.props.modalOpened && !prevProps.modalOpened && typeof this.state.toggleModal === 'function') {
      this.state.toggleModal()
    }
  }

  handleCloseModal = () => {
    this.props.onClose()
  }

  handleCreate = (setDataCl: Function, sendCallback: Function, toggleModal: Function) => {
    const data = {
      contact: {
        phoneNumber: this.props.formData.getIn(['policyHolder', 'phoneNumber'], ''),
      },
      requestId: this.props.requestId,
      productName: this.props.productName,
      website: this.props.website,
      affiliate: this.props.affiliate,
      lastName: this.props.formData.getIn(['policyHolder', 'lastName'], ''),
      quoteId: this.props.data.callbackQuoteId || '',
      callTopic: this.props.data.contractId ? 'customerService' : 'sales',
      contractId: this.props.data.contractId || '',
    }
    this.setState({ setDataCl, sendCallback, toggleModal })
    setDataCl(data)

    return data
  }

  handleFinish = (success: boolean) => {
    this.handleCloseModal()
    if (success && this.props.addGtmEvent && this.props.productName !== 'travel') {
      this.props.addGtmEvent('Send', 'Telefon')
    }
  }

  handleGoBack = () => {
    this.props.goBack()
    this.handleCloseModal()
  }

  handleRenderCallbackTopSection = () =>
    this.props.showText ? (
      <div className="mb-3">
        <p>{I18n.translate('components.callbackForm.p1')}</p>
        <p>
          {I18n.translate('components.callbackForm.p2', {
            link: (
              <a className="btn-link text-primary" onClick={this.handleGoBack}>
                {I18n.translate('components.callbackForm.goBack')}
              </a>
            ),
          })}
        </p>
      </div>
    ) : null

  render() {
    const { isBackOffice, modalOpened, token, renderNotOpened, confirmModalEnabled } = this.props
    if (!modalOpened && !renderNotOpened) {
      return null
    }

    return (
      <CallbackFormSubmodule
        confirmModalEnabled={confirmModalEnabled}
        isBackOffice={isBackOffice}
        onCreate={this.handleCreate}
        onFinish={this.handleFinish}
        pushShowModal={false}
        renderOnTheTop={this.handleRenderCallbackTopSection}
        showInMobileVersion
        token={token}
      />
    )
  }
}
